export const TWITTER_URL = "https://twitter.com/iron_vertex";
export const IV_EMAIL = "inquiries@ironvertex.com";
export const YOUTUBE_URL = "https://www.youtube.com/c/IronVertex";
